import { useHistory } from "react-router-dom";

export const removeQueryString = (history: ReturnType<typeof useHistory>, parameter: string) => {
  const url = new URL(window.location.toString());

  url.searchParams.delete(parameter);

  history.push(url);
};
